import { render } from "./SchoolList.vue?vue&type=template&id=72100a53&scoped=true"
import script from "./SchoolList.vue?vue&type=script&lang=js"
export * from "./SchoolList.vue?vue&type=script&lang=js"

import "./SchoolList.vue?vue&type=style&index=0&id=72100a53&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hagino\\work\\src\\plus-manabi\\mplus-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72100a53"]])

export default __exports__